import React from "react";

const File = ( props ) => {

    return (
        <g id="path">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
        </g>
    )
};

export default File;
